import React, { Component } from "react";
import { api } from "../../utils/api";

function getCurrentSlab() {
  const month = new Date().getMonth() + 1;
  const year = new Date().getFullYear();
  if (month >= 4 && month <= 9)
    return {
      label: `Apr–Sep ${year}`,
      from: `${year}-04-01`,
      to: `${year}-09-30`,
    };
  const fromYear = month >= 10 ? year : year - 1;
  const toYear = month >= 10 ? year + 1 : year;
  return {
    label: `Oct ${fromYear}–Mar ${toYear}`,
    from: `${fromYear}-10-01`,
    to: `${toYear}-03-31`,
  };
}

class PLBSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prevNights: null,
      prevPLB: null,
      loading: false,
      slab: null,
    };
  }

  componentDidMount() {
    if (this.props.formData?.hotel_name) this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.formData?.hotel_name !== prevProps.formData?.hotel_name)
      this.fetchData();
  }

  async fetchData() {
    const hotel = this.props.formData?.hotel_name;
    if (!hotel) return;
    this.setState({ loading: true });
    const slab = getCurrentSlab();
    this.setState({ slab });
    try {
      const { data } = await api.get("/bookings/plb-nights", {
        params: { hotel_name: hotel, from_date: slab.from, to_date: slab.to },
      });
      this.setState({
        prevNights: parseInt(data.total_nights) || 0,
        prevPLB: parseInt(data.total_plb_nights) || 0,
        loading: false,
      });
    } catch {
      this.setState({ prevNights: 0, prevPLB: 0, loading: false });
    }
  }

  render() {
    const { formData, onChange } = this.props;
    const { prevNights, prevPLB, loading, slab } = this.state;
    const currentNights = parseInt(formData.no_of_nights) || 0;
    const nightOnQuery = (prevNights || 0) + currentNights;

    const lbl = {
      fontSize: 10,
      fontWeight: 700,
      color: "#6B7280",
      textTransform: "uppercase",
      letterSpacing: "0.06em",
      marginBottom: 6,
      display: "block",
    };
    const infoBox = (val, bg, borderColor, textColor) => ({
      height: 44,
      background: bg,
      border: `1.5px solid ${borderColor}`,
      borderRadius: 10,
      display: "flex",
      alignItems: "center",
      padding: "0 14px",
      fontSize: 15,
      fontWeight: 800,
      color: textColor,
    });

    return (
      <div style={{ fontFamily: "Sora,sans-serif" }}>
        <h3
          style={{
            fontSize: 15,
            fontWeight: 800,
            color: "#1E2D4F",
            margin: "0 0 6px",
          }}
        >
          PLB — Productivity Linked Bonus
        </h3>
        {slab && (
          <p style={{ fontSize: 11, color: "#6B7280", margin: "0 0 20px" }}>
            Season: <strong>{slab.label}</strong> &nbsp;·&nbsp; Hotel:{" "}
            <strong>{formData.hotel_name}</strong>
          </p>
        )}

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: 16,
          }}
        >
          {/* Night on Query */}
          <div>
            <span style={lbl}>Night on Query</span>
            <div style={infoBox(nightOnQuery, "#EFF6FF", "#BFDBFE", "#1E40AF")}>
              🌙 {loading ? "…" : nightOnQuery}
            </div>
            <p style={{ fontSize: 11, color: "#6B7280", marginTop: 5 }}>
              Prev: {loading ? "…" : prevNights || 0} + Current: {currentNights}
            </p>
          </div>

          {/* Previous PLB Given */}
          <div>
            <span style={lbl}>Previous PLB Given</span>
            <div style={infoBox(prevPLB, "#F5F3FF", "#DDD6FE", "#5B21B6")}>
              🎯 {loading ? "…" : (prevPLB ?? 0)}
            </div>
            <p style={{ fontSize: 11, color: "#6B7280", marginTop: 5 }}>
              Total PLB nights in this season
            </p>
          </div>

          {/* PLB Night — user input */}
          <div>
            <span style={lbl}>PLB Night</span>
            <input
              type="number"
              min="0"
              step="1"
              placeholder="Enter nights"
              value={formData.plb_nights ?? ""}
              onChange={(e) =>
                onChange(
                  "plb_nights",
                  e.target.value === "" ? "" : parseInt(e.target.value) || 0,
                )
              }
              onFocus={(e) => {
                e.target.select();
                e.target.style.borderColor = "#1E2D4F";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#D1D5DB";
              }}
              style={{
                width: "100%",
                height: 44,
                border: "1.5px solid #D1D5DB",
                borderRadius: 10,
                padding: "0 14px",
                fontSize: 15,
                fontWeight: 700,
                fontFamily: "Sora,sans-serif",
                outline: "none",
                boxSizing: "border-box",
                color: "#111827",
              }}
            />
            <p style={{ fontSize: 11, color: "#6B7280", marginTop: 5 }}>
              Manually entered
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default PLBSection;
